import { Clock, Instagram, MapPin, MessageCircle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import {
    ADDRESS,
    INSTAGRAM_HANDLE,
    INSTAGRAM_URL,
    PHONE_DISPLAY,
    WHATSAPP_URL,
} from "../constants/site";
import { useLang } from "../i18n/LangContext";

const Contact = () => {
    const { t } = useLang();
    return (
    <section id="contato" data-testid="contact-section" className="border-t border-burnt/15 wine-section py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
            <SectionHeading
                center
                index={t.contact.index}
                eyebrow={t.contact.eyebrow}
                title={
                    <>
                        {t.contact.titleA}
                        <span className="italic text-gold">{t.contact.titleB}</span>
                    </>
                }
            />

            <Reveal delay={0.2} className="mt-12 text-center">
                <a
                    data-testid="contact-cta-whatsapp"
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="group inline-flex items-center gap-4 rounded-full bg-gold px-10 py-5 text-base font-medium text-noir shadow-[0_10px_50px_rgba(196,162,119,0.25)] transition-all duration-300 hover:scale-[1.04] hover:bg-burnt"
                >
                    <MessageCircle className="h-5 w-5 transition-transform duration-300 group-hover:-rotate-12" />
                    {t.contact.cta} · {PHONE_DISPLAY}
                </a>
                <p className="mt-5 text-sm text-taupe">
                    {t.contact.sub}
                </p>
            </Reveal>

            <div className="mt-16 grid gap-6 md:grid-cols-3">
                <Reveal delay={0.1}>
                    <div className="h-full rounded-3xl border border-burnt/20 bg-noir/60 p-8 transition-colors duration-500 hover:border-gold/40">
                        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-gold/15">
                            <MapPin className="h-5 w-5 text-gold" />
                        </div>
                        <h3 className="mt-6 font-serif text-xl text-cream">{t.contact.studioTitle}</h3>
                        <p data-testid="contact-address" className="mt-3 text-sm leading-relaxed text-taupe">
                            {ADDRESS}
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.2}>
                    <div className="h-full rounded-3xl border border-burnt/20 bg-noir/60 p-8 transition-colors duration-500 hover:border-gold/40">
                        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-gold/15">
                            <Clock className="h-5 w-5 text-gold" />
                        </div>
                        <h3 className="mt-6 font-serif text-xl text-cream">{t.contact.hoursTitle}</h3>
                        <p data-testid="contact-hours" className="mt-3 text-sm leading-relaxed text-taupe">
                            {t.contact.hours1}
                            <br />
                            {t.contact.hours2}
                        </p>
                        <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-burnt">
                            {t.contact.hoursTag}
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.3}>
                    <a
                        data-testid="contact-instagram-link"
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noreferrer"
                        className="group block h-full rounded-3xl border border-burnt/20 bg-noir/60 p-8 transition-colors duration-500 hover:border-gold/40"
                    >
                        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-gold/15">
                            <Instagram className="h-5 w-5 text-gold" />
                        </div>
                        <h3 className="mt-6 font-serif text-xl text-cream">{t.contact.instaTitle}</h3>
                        <p className="mt-3 text-sm leading-relaxed text-taupe">
                            {t.contact.instaText}
                        </p>
                        <p className="mt-5 text-sm font-medium text-gold transition-colors group-hover:text-burnt">
                            {INSTAGRAM_HANDLE}
                        </p>
                    </a>
                </Reveal>
            </div>
        </div>
    </section>
    );
};

export default Contact;
